<div class="tem-field" [formGroup]="group">
        <label class="tem-field-label" [attr.for]="config.IDCOLUMN">{{config.COLUMNDESC}}<span class="tem-field-required" *ngIf="config.ISIDENTITY != 1 && config.ISREQUIRED == 1"> *</span></label>
        <div class="tem-field-row">
                <nz-date-picker [attr.tabindex]="tabindex" [formControlName]="config.COLUMNNAME" [nzPlaceHolder]="config.PLACEHOLDER" nzFormat="dd/MM/yyyy" nzAllowClear (ngModelChange)="editing()" (nzOnOpenChange)="$event ? null : bluring({ type: 'blur' })"></nz-date-picker>
                <button nz-button nzType="text" nzSize="small" *ngIf="toolTipText!=null" [tooltip]="toolTipText">
                        <nz-icon nzType="question-circle"></nz-icon>
                </button>
                <form-field-properties [information]="config" [entityDesc]="entityDesc" [entityName]="entityName" *ngIf="canConfig" [row]="row"></form-field-properties>
        </div>
</div>
